import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { paperProps, REPORT_UPDATE_URL } from '../../../constants';
import { yupResolver } from '@hookform/resolvers/yup';
import { postStopApi, setStopApi } from '../../../services/StopApi/StopApi';
import FormInputText from '../../common/Forms/FormTextField';
import {
  getBackdrop,
  getDialogHeading,
  getFormSuccess,
  getSaveCancel,
} from '../../common/commonUtils/commonUtils';
import { Form } from '../../ui/styled';
import { reportValidation } from '../ReportUtils/reportValidations';

const ReportDialog = (props) => {
  const { open, setOpen, openBackdrop, authToken, fetchData } = props;
  const [formSuccess, setFormSuccess] = useState(false);
  const [isNewReportForm, setIsNewReportForm] = useState(false);

  const reportForm = useSelector((state) => state.reportForm);
  const { newReportForm, rptId, reportTitle } = reportForm;

  const defaultValue = {
    rptId: rptId,
    reportTitle: reportTitle,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(reportValidation),
  });
  const { handleSubmit, reset, control, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.rptId, defaultValue.reportTitle]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = (data) => {
    const { reportTitle } = data;
    const url = `${REPORT_UPDATE_URL}`;
    const authorization = authToken;
    const payload = {
      rptId: newReportForm ? 0 : rptId,
      reportTitle: reportTitle,
    };
    if (newReportForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewReportForm(true);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsNewReportForm(false);
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const getReportForm = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInputText
            name='reportTitle'
            control={control}
            errors={!!errors.reportTitle}
            helperText={errors?.reportTitle?.message}
            label='Report Title'
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={paperProps}>
        {openBackdrop ? (
          getBackdrop(openBackdrop)
        ) : (
          <>
            {getDialogHeading('Report Id', defaultValue?.rptId, handleClose)}
            <Form>
              {getReportForm()}
              {getSaveCancel(handleClose, null, handleSubmit(onSubmit))}
            </Form>
          </>
        )}
      </Dialog>
      {getFormSuccess(formSuccess, setFormSuccess, isNewReportForm)}
    </>
  );
};

export default ReportDialog;
